import { ThemeConfig } from 'antd/es/config-provider/context'
import { theme } from './theme'

export const borderRadius = 16
const fontSize = 16

// use fontSize 16 as default as soon as this is safe
const antdTheme: ThemeConfig = {
  token: {
    fontFamily: theme.font.family.sansSerif,
    colorPrimary: theme.color.status.primary,
    // TODO override local component (Tooltip)
    colorBgSpotlight: theme.palette.white,
    // why is this used here
    // this breaks button color ( for modal at least )
    // this breaks range-picker dropdown text color
    colorTextLightSolid: theme.palette.black
  },
  components: {
    Tooltip: {
      colorBgSpotlight: 'rgb(51, 51, 51)',
      colorTextLightSolid: theme.palette.white
    },
    Table: {
      borderRadius
    },
    Pagination: {
      borderRadius: 9
    },
    Menu: {
      fontSize
    },
    Input: {
      fontSize,
      // i set this to 1.5 because of the Input.Search component
      // which is not aligned to the search icon
      lineHeight: 1.5
    },
    Dropdown: {
      fontSize
    },
    // this is here to override the 'colorTextLightSolid' from the token
    Button: {
      colorTextLightSolid: theme.color.neutral.color11
    },
    // this is here to override the 'colorTextLightSolid' from the token
    DatePicker: {
      colorTextLightSolid: theme.color.neutral.color11
    },
    Descriptions: {
      colorTextSecondary: theme.color.neutral.color5,
      colorText: theme.color.neutral.color3,
      colorFillAlter: theme.color.neutral.color10,
      padding: 8,
      paddingLG: 16
    }
  }
}

export default antdTheme
